import { useTranslation } from 'react-i18next';
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { InputForm } from '@/components/ui/inputForm';

const InputNumberForm = ({
  name,
  placeholder,
  icon,
  label = '',
  className = '',
  isRequired = false,
  customValidation,
  acceptNegative = false,
  isDisabled = false,
  maxNumber = null,
  minNumber = null,
  showText = true,
  onlyMinNumber = false,
  description = '',
  currencySymbol = null,
  inputClassName = '',
  ...others
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });

  const defaultValidationRule = {
    validate: (value) => {
      if (maxNumber !== null && minNumber !== null) {
        if ((value > maxNumber || value < minNumber) && showText) {
          return `${t('valuesFrom')}${minNumber} ${t('and')} ${maxNumber}`;
        } else if (value > maxNumber || value < minNumber) return t('invalidNumber');
      } else if (value < minNumber && onlyMinNumber) {
        return `${t('invalidMinNumber')} ${minNumber}`;
      } else if (value < 0 && !acceptNegative) {
        return t('onlyPositive');
      }
    },
  };

  const validationRules = customValidation || defaultValidationRule;

  if (isRequired) {
    validationRules.required = t('required');
  }

  return (
    <div className={className}>
      <FormField
        name={name}
        defaultValue=''
        rules={validationRules}
        render={({ field, fieldState }) => {
          const handleChange = (e) => {
            const inputValue = e.target.value;

            if (inputValue === '-') {
              field.onChange(e);
              return;
            }

            const numericValue = Number(inputValue);
            if (isNaN(numericValue)) return;

            // Validar contra el máximo (positivo o negativo)
            if (maxNumber !== null && Math.abs(numericValue) > Math.abs(maxNumber)) {
              return;
            }

            field.onChange(e);
          };

          return (
            <div>
              <FormItem>
                {label ? <FormLabel>{label}</FormLabel> : null}
                <FormControl>
                  <div className='tw-relative tw-flex'>
                    {currencySymbol && (
                      <div
                        className={`tw-flex tw-items-center tw-justify-center tw-border tw-border-r-0 tw-rounded-md tw-rounded-r-none tw-bg-zinc-100 tw-px-3 tw-border-zinc-200 tw-text-gray-700 ${
                          isDisabled ? 'tw-opacity-50' : ''
                        }`}
                      >
                        {currencySymbol}
                      </div>
                    )}
                    <InputForm
                      disabled={isDisabled}
                      placeholder={placeholder}
                      {...field}
                      type='number'
                      error={fieldState['error']?.message}
                      onChange={handleChange}
                      className={`${currencySymbol ? 'tw-rounded-l-none' : ''} ${inputClassName}`}
                      style={{ visibility: 'visible', position: 'static', zIndex: 'auto' }}
                    />
                  </div>
                </FormControl>
                {description ? (
                  <FormDescription className='!tw-mt-1'>{description}</FormDescription>
                ) : null}
                {fieldState['error']?.message && (
                  <div className='d-flex align-items-center error-content'>
                    <i className='fas fa-exclamation-triangle text-danger mr-2'></i>{' '}
                    <p className='text-danger p-0 m-0'>{fieldState['error']?.message}</p>
                  </div>
                )}
              </FormItem>
            </div>
          );
        }}
      />
    </div>
  );
};

export default InputNumberForm;
